import styled from 'styled-components';
import { DefaultText } from '../../../styles/global/css/GlobalText';
import { BorderColor2, DisabledColor, RedSidely, SurfaceColor } from '../../../styles/global/css/Utils';

const TextAreaContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const TextArea = styled.textarea`
    background: ${SurfaceColor};
    border: 1px solid ${BorderColor2};
    box-sizing: border-box;
    border-radius: 6px;
    height: 150px;
    width: 100%;
    min-width: 250px;
    font-size: 13px;
    padding: 10px;
    &:disabled {
        background-color: ${DisabledColor};
        border-color: ${DisabledColor};
    }
`;

const TextAreaLabel = styled.p`
    ${DefaultText}
`;

const SpanAreaLabel = styled.span`
    ${DefaultText}
    color: ${RedSidely};
`;

const HorizontalContainer = styled.div<{ gap?: string }>`
    display: flex;
    align-items: center;
    ${p => p.gap ? `gap ${p.gap};` : ''}
`;

const SwitchText = styled.p`
    ${DefaultText}
    margin-right: 5px;
`;

export {
	TextAreaContainer,
	TextArea,
	TextAreaLabel,
	HorizontalContainer,
	SwitchText,
	SpanAreaLabel
};
